import React, { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { useLocation } from "react-router-dom"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import OrderConfirmedView from '../../components/Common/OrderConfirmed/View'

const Confirmation = (props) => {
  const { state } = useLocation()

  useEffect(() => {
    if (isEmpty(state)) {
      toastr.warning('Datos inválidos', 'Error')
      props.history.goBack()
    }
  }, [state]) // eslint-disable-line

  return (
    <React.Fragment>
      <div className="page-content">
        {!isEmpty(state) && (
          <OrderConfirmedView
            cart={state.cart}
            settings={state.settings}
            paymentMethods={state.paymentMethods}
            orderConfirmed={state.orderConfirmed}
            user={props.user}
            paymentType={state.paymentType}
            oxxoResponse={state.oxxoResponse}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Confirmation
